import { Pipe, PipeTransform } from '@angular/core';
import { urlifyTitle } from './urlify-title';

@Pipe({
  name: 'urlifyTitle',
  standalone: true,
})
export class UrlifyTitlePipe implements PipeTransform {
  public transform(title: string): string {
    return urlifyTitle(title);
  }
}
